module.exports = Date.now || now

function now() {
    return new Date().getTime()
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/date-now/index.js
 ** module id = 8
 ** module chunks = 0
 **/